import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { environment } from 'projects/foreign-admits/src/environments/environment';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class TitleChangeService {

  admissionsTabTitles = this.configService.getConfig1("foreignAssist", "admissionsCompanyAlternativeNames");


  constructor(private title: Title, private router: Router, private activatedRoute: ActivatedRoute, private configService: ConfigService) { }


  updateTitle() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd), map(() => {
      let route = this.activatedRoute;

      while (route.firstChild) {
        route = route.firstChild;
      }

      return route.snapshot.paramMap.get('puid') || '';
    })
    ).subscribe((puid) => {
      
      if (puid) {
        if(this.admissionsTabTitles[puid]?.displayText){
        this.title.setTitle(this.admissionsTabTitles[puid]?.displayText);
        }else{
        this.title.setTitle('CourseFinder');
        }
      } else {
        this.title.setTitle('CourseFinder');
      }
    });
  }

  private updateFavicon(iconPath: string) {
    let link: HTMLLinkElement = document.querySelector("link[rel~='icon']") || document.createElement('link');
    link.rel = 'icon';
    link.href = iconPath;
    document.getElementsByTagName('head')[0].appendChild(link);
  }
}
